export default class Checkboxes {
    constructor($el, options = {}) {
        this.DOM = { $el }
        this.options = { ...Checkboxes.prototype.defaults, ...options }
        this.init()
    }

    init() {
        this.DOM.$$checkbox = this.DOM.$el.querySelectorAll('input[type="checkbox"]')
        this.checked = 0
        this.min = this.DOM.$el.dataset[this.options.attrMin]
        this.minMessage = this.DOM.$el.dataset[this.options.attrMinMessage]
        this.max = this.DOM.$el.dataset[this.options.attrMax]
        this.toggleAll = this.DOM.$el.dataset[this.options.attrToggleAll]

        this.DOM.$$checkbox.forEach($checkbox => {
            $checkbox.addEventListener('change', this.onCheckboxChange.bind(this), { passive: true })
        })

        if (this.toggleAll) {
            this.DOM.$el.querySelectorAll(this.options.selectorToggleAll).forEach($toggle => {
                $toggle.addEventListener('click', () => {
                    if (this.DOM.$$checkbox[0]) {
                        let state = this.DOM.$$checkbox[0].checked;
                        this.DOM.$$checkbox.forEach($checkbox => {
                            $checkbox.checked = !state;
                        });
                    }
                })
            })
        }

        this.update()
    }

    onCheckboxChange(e) {
        // Reset state
        if (this.minMessage) {
            this.DOM.$$checkbox.forEach($el => $el.setCustomValidity(""))
        }
        this.update()
    }

    update() {
        const $$unchecked = this.DOM.$el.querySelectorAll('input[type="checkbox"]:not(:checked)')
        const numChecked = this.DOM.$el.querySelectorAll('input[type="checkbox"]:checked').length
        if (this.max) {
            $$unchecked.forEach($el => $el.disabled = (numChecked >= this.max))
        }

        if (this.min) {
            $$unchecked.forEach($el => {
                $el.required = (numChecked < this.min)
                if (this.minMessage && numChecked < this.min) {
                    $el.setCustomValidity(this.minMessage)
                }
            })
        }
    }
}

Checkboxes.prototype.defaults = {
    attrMax: 'checkboxesMax',
    attrMin: 'checkboxesMin',
    attrMinMessage: 'checkboxesMinMessage',
    attrToggleAll: 'checkboxesToggleAll',
    selectorToggleAll: '.js-checkboxes-toggleAll'
}